import { useEffect } from 'react';

import { useCallbackRef } from '@tg-web/utils';

import { OjEvent, StackEvent, useMissEventV2 } from '../../../shared/api';
import { RecurrentType } from '../../recurrency';
import { useDeletePrompt } from './useDeletePrompt';

export function useMissEventHandler(
  event: OjEvent | StackEvent,
  onSuccess?: () => void,
) {
  const onSuccessCallbackRef = useCallbackRef(onSuccess);
  const deletePrompt = useDeletePrompt(true);
  const missEvent = useMissEventV2();

  useEffect(() => {
    if (missEvent.isSuccess) {
      onSuccessCallbackRef();
    }
  }, [missEvent.isSuccess, onSuccessCallbackRef]);

  // TODO: handle error

  return [
    async () => {
      let dependentMiss = 0;
      const recurrentType = event.recurrent_type;
      if (recurrentType !== RecurrentType.noRecurrency) {
        const promptResult = await deletePrompt();
        if (promptResult === 'close' || promptResult === 'discard') {
          return;
        }
        if (promptResult === 'secondary') {
          dependentMiss = 1;
        }
      }

      missEvent.mutate({
        body: { dependent_miss: dependentMiss },
        pathParams: { id: event.id },
      });
    },
    missEvent,
  ] as const;
}
